// The menu and HUD design system (#225): one surface, one heading scale, one
// list row for every pick, so the lobby, the pause menu, the cards and the
// HUD read as one set. Round 2 made it a game's menus rather than a web
// page's: panels with hard ink edges, the heavy italic display type the
// HUD already uses, and the sunset accent. Round 3 lifted round 2's night
// panels: everything on a panel is a `surface` token (`index.css`), so the
// panels' lightness is one swap there. Button looks are in `buttons.ts`.
// Add sizing (width, padding) where it's used.

/** A card or menu over the park: a surface panel with a hard drop shadow. */
export const PANEL = "rounded-lg border-2 border-ink bg-surface/95 text-on-surface shadow-[0_5px_0_var(--color-ink)]";

/** A full menu (pause, results, What's new): a panel with room inside. */
export const DIALOG = `${PANEL} p-5`;

/** A section's small heading inside a panel; `LABEL_TYPE` alone takes another colour. */
export const LABEL_TYPE = "text-[0.7rem] font-black uppercase italic tracking-[0.18em]";
export const LABEL = `${LABEL_TYPE} text-label`;

/** A screen or card title: the display type, heavy italic capitals. Size it where it's used. */
export const TITLE = "font-black uppercase italic leading-none tracking-tight";

/** A muted line under a title or a row: what a choice does, a control hint. */
export const NOTE = "text-xs font-semibold text-on-surface-soft";

/** The dim scrim behind a menu. */
export const SCRIM = "bg-ink/35";

/** A row on a panel that isn't picked: a list's other rows, a goal still to do. */
export const ROW = "border-line bg-surface-soft text-on-surface";

/** The picked row: the accent fill. */
export const ROW_ON = "border-ink bg-accent text-on-accent shadow-[0_3px_0_var(--color-ink)]";

/** A small pick you tap or click straight on (the hill's ride pick): the current one filled. */
export function tile(on: boolean): string {
  return `flex flex-col items-center justify-center gap-1 rounded-md border-2 p-1.5 text-center text-xs font-black uppercase italic focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-focus ${
    on ? ROW_ON : `${ROW} hover:border-accent`
  }`;
}
